import 'angular';
import 'angular-resource';
import routesModule from '../../../utilities/routes_module';

const moduleDependencies = ['ngResource'];

angular
  .module('fundingSearchApp.models.reportApiService', moduleDependencies)
  .factory('reportApiService', ['$resource',
    $resource => $resource( `${routesModule.api_path('funding_projects')}/:type/:id` )
  ]);
